module.exports = __webpack_public_path__ + "static/media/redeem.55ff24a2.svg";